import './style_last_flight.css';
import no_data_img from '../../images/NoData.png';

function LastFlight() {
    return(
        <>
            <div className="my-last-flight">
                <div className="container">
                    <div className='no-data'>
                        <img src={no_data_img} />
                        <h1>لا يوجد حجوزات طيران سابقه</h1>
                    </div>
                </div>
            </div>
        </>
    );
};


export default LastFlight;